import React from 'react';
import {
  Box,
  Button,
  Text,
  Heading,
  Flex,
  useColorModeValue,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';

const ConfirmationPopup = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  description = 'Do you want to proceed with this action?',
  confirmButtonText = 'Continue',
  cancelButtonText = 'Cancel',
}) => {
  const bgCard = useColorModeValue('white', 'gray.700');
  const textColor = useColorModeValue('gray.700', 'white');

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg={bgCard}>
        <ModalHeader>
          <Heading as="h4" size="md" color={textColor}>
            {title}
          </Heading>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text color="gray.500">{description}</Text>
        </ModalBody>
        <ModalFooter>
          <Flex justify="flex-end" w="100%">
            <Button variant="outline" colorScheme="gray" mr={3} onClick={onClose}>
              {cancelButtonText}
            </Button>
            <Button colorScheme="blue" onClick={onConfirm}>
              {confirmButtonText}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmationPopup;
